import { Button, Row } from "antd";

type FooterProps = {
  isClosing: boolean;
  isLoading: boolean;
  close: () => void;
  submit: () => void;
};

export const Footer = ({
  isClosing,
  isLoading,
  close,
  submit,
}: FooterProps) => {
  return (
    <Row className="justify-end pt-2 mr-6">
      <Button
        type="primary"
        shape="round"
        onClick={submit}
        disabled={isLoading || isClosing}
        loading={isClosing}
      >
        Submit & Close Task
      </Button>
      <Button
        className="ml-2"
        shape="round"
        disabled={isLoading || isClosing}
        onClick={close}
      >
        Cancel
      </Button>
    </Row>
  );
};
